import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";

export interface PresentationType {
    id: number;
    name: string;
    generatePages: number[];
    additionalPages: AdditionalPages[];
    hasConvenience: boolean;
}

export interface AdditionalPages {
    index: number;
    title: string;
    content?: string;
    imagem?: string;
}

const usePresentation = () => {
    const { setLoading } = useContext(LoadingContext);
    const [htmlApresentation, setHtmlApresentation] = useState("");
    const showToast = useToast();

    // const generatePdf = async (empresas: PresentationType[], month: string, year: number, hasFinalConsolidation: boolean, hasFinalConsolidationConveniencia: boolean, hasFinalConsolidationConvenienciaPosto: boolean) => {
    //     setLoading(true);
    //     try {
    //         const response = await api.post('/presentation/generate-pdf', { empresas, month, year, hasFinalConsolidation, hasFinalConsolidationConveniencia, hasFinalConsolidationConvenienciaPosto }, { responseType: 'blob' });
    //         const url = window.URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `ConsolidatedReport.pdf`);
    //         document.body.appendChild(link);
    //         link.click();
    //         window.URL.revokeObjectURL(url);
    //         showToast("success", "Apresentação gerada com sucesso!");
    //     } catch (error: any) {
    //         console.error("Erro ao gerar PDF:", error);
    //         showToast("error", `Erro ao gerar apresentação: ${error.response.data}`);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const generatePdf = async (
        empresas: PresentationType[], 
        month: string, 
        year: number, 
        hasFinalConsolidation: boolean, 
        hasFinalConsolidationConveniencia: boolean, 
        hasFinalConsolidationConvenienciaPosto: boolean
    ) => {
        setLoading(true);
        try {
            const response = await api.post(
                '/presentation/generate-pdf', 
                { empresas, month, year, hasFinalConsolidation, hasFinalConsolidationConveniencia, hasFinalConsolidationConvenienciaPosto }, 
                { responseType: 'blob' }
            );
    
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ConsolidatedReport.pdf`);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            showToast("success", "Apresentação gerada com sucesso!");
        } catch (error: any) {
            setLoading(false);
            console.error("Erro ao gerar PDF:", error);
    
            if (error.response?.data instanceof Blob) {
                const blob = error.response.data;
    
                const errorText = await blob.text();
    
                try {
                    const errorData = JSON.parse(errorText);
                    showToast("error", `${errorData.message}${errorData.page}. Detalhes: ${errorData.details}`);
                } catch (parseError) {
                    showToast("error", `Erro inesperado: ${errorText}`);
                }
            } else {
                showToast("error", "Erro inesperado ao gerar apresentação.");
            }
        } finally {
            setLoading(false);
        }
    };    

    async function handleGenerateHTML(
        empresas?: PresentationType[],
        month?: string,
        year?: number,
        hasFinalConsolidation?: boolean,
        hasFinalConsolidationConveniencia?: boolean,
        hasFinalConsolidationConvenienciaPosto?: boolean
    ): Promise<any | null> {
        setLoading(true);
        try {
            let response = await api.post(`/presentation/generate-pdf-html`, { empresas, month, year, hasFinalConsolidation, hasFinalConsolidationConveniencia, hasFinalConsolidationConvenienciaPosto });
            setLoading(false);
            setHtmlApresentation(response.data);
            return response.data;
        } catch (error: any) {
            setLoading(false);
            // showToast("error", `Erro ao gerar apresentação: ${error.response.data}`);
            if (error.response && error.response.data) {
                const { page, message, details } = error.response.data;
                showToast("error", `Erro na ${page}: ${message}. Detalhes: ${details}`);
            } else {
                showToast("error", "Erro desconhecido ao gerar apresentação. Tente novamente.");
            }
            return null;
        } finally {
            setLoading(false);
        }
    }

    return {
        generatePdf,
        handleGenerateHTML,
        htmlApresentation,
        setHtmlApresentation,
    };
};

export default usePresentation;